export default __webpack_public_path__ + "static/media/reports_01.6da52b61.svg";